import React from "react";

/**
 * Official Fuoco IN brand mark. Renders the company logo PNG served from
 * `/public/fuocoin-logo-256.png` (hi-res for retina). The `size` prop sets
 * the rendered height in pixels and lets the natural aspect ratio drive
 * the width so the logo never deforms.
 */
export default function FlameHeart({ className = "", size = 28, alt = "Fuoco IN" }) {
  return (
    <img
      src="/fuocoin-logo-256.png"
      alt={alt}
      height={size}
      style={{ height: `${size}px`, width: "auto" }}
      className={className}
      draggable={false}
    />
  );
}
